import { __commonJSMin as e } from "../../../../../../../../_virtual/_rolldown/runtime.js";
import { require_browser as t } from "../../../../../../isomorphic-dompurify@2.34.0_canvas@3.2.0/bundled_deps/isomorphic-dompurify/browser.js";
import { require_custom_sanitizers as n } from "./custom-sanitizers.js";
import { require_config as r } from "./config/index.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0/node_modules/@intercom/intercom-sanitizer/dist/html/sanitizer.js
var i = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.sanitizeHtml = c;
	var i = s(t()), a = s(n()), o = s(r());
	function s(e) {
		return e && e.__esModule ? e : { default: e };
	}
	i.default.addHook("uponSanitizeElement", function(e, t) {
		a.default[e.tagName] && a.default[e.tagName](e, t);
	});
	function c(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		return i.default.sanitize(e, (0, o.default)(t.config));
	}
}));
//#endregion
export default i();
export { i as require_sanitizer };
